import posthog from 'posthog-js'

export default {
  install (app) {
    const posthogToken = window.globals?.VUE_APP_POSTHOG_TOKEN
    const posthogApiHost = window.globals?.VUE_APP_POSTHOG_API_HOST

    if (!posthogToken || !posthogApiHost) {
      console.warn('PostHog is not initialized')
      app.config.globalProperties.$posthog = posthog
      return
    }

    posthog.init(posthogToken, {
      api_host: posthogApiHost,
      defaults: '2026-05-30',
      cookieless_mode: 'on_reject',
      autocapture: false
    })

    app.config.globalProperties.$posthog = posthog
  }
}
